import { BFF_BASE_URL } from "@config";

export const URL_SYNTAX = {
  SLASH: "/",
  QUERY_DELIMITER: "?",
  AMPERSAND: "&",
  EQUALS: "="
}

export const REST_METHODS = {
  GET: "get",
  POST: "post",
  PUT: "put",
  PATCH: "patch",
  DELETE: "delete"
}

export const ENDPOINTS = {
  AURORA: `${BFF_BASE_URL}/api/aurora`
};

export const USERS = {
  login: "authenticate",
  checkSession: "check-session",
  forgotPassword: "forgot-password",
  resetPassword: "reset-password",
  updateUser: "update-user",
  createUser: "create-user",
  users: "users",
  saveFilter: "save-filter",
  editFilter: "edit-filter",
  deleteFilter: "delete-filter",
  getFilters: "get-filters",
  extendSession: "extend-session",
};

export const AURORA = {
  // Path
  STATUS: "status",
  IMPORT_DATE: "import-date",
  ALLOCATIONS: "allocations",
  ENGAGEMENTS: "engagements",
  PROFESSIONALS: "professionals",
  HOURS_REPORT: "hours-report",
  START_DATES: "hours-report-dates",
  FUTURE_HOURS_REPORT: "future-hours-report",
  TOTAL_HOURS : "total-hours",
  NOTES: "notes",
  SKILLS: "skills",
  PTO: "pto",
  UPLOAD: "upload-url",
  // Query
  DATE: "date",
  MANAGEMENT: "management",
  FULLTIME: "fulltime",
  PROCESSING_FILE:"processing-file",
  DRAFTS: "drafts",
}
